module.exports = __webpack_public_path__ + "../resources/images/EditorImage-cbf82dda59d4ed6e4d355723c49c493b.svg";